import React, { useState } from "react";
import style from './importVariantModal.module.scss';
import Modal from "../Modal/Modal"
import Button from "../Button/button"
import Toast from "../Toast/Toast"
import FileUpload from "./fileUpload/fileUpload";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import { GenerateFile, ImportVariantFile, ProcessFile } from "../../actions/APIcalls"
import { serverAddress } from "../../helpers/axiosFiles/axios";

const ImportVariantModal = (props) => {
    const [status, setStatus] = useState('empty') //empty , isUploading, uploadedWithErrors, suceessful,uploadedWithNoErrors
    const [toast, setToast] = useState({ text: '', type: 'error' })
    const [file, setFile] = useState()
    const [progress, setProgress] = useState()
    const [errors, setErrors] = useState([])
    const [fileDownloadLink, setFileDownloadLink] = useState('')
    const [clickNumber, setClickNumber] = useState(0)
    const [parsedSuccessfully, setParsedSuccessfully] = useState({ parsed: 0, count: 0 })
    const [isProcessingFile, setIsProcessingFile] = useState(false)
    const [uploadedFileAddress, setUploadedFileAddress] = useState('')
    const [isDownloading, setIsDownloading] = useState(false)
    const [saveCount, setSaveCount] = useState({ count: 0 })

    const closeModalFunction = () => {
        setToast({ text: '', type: 'error' })
        setSaveCount({ ...saveCount, count: 0 })
        setFile(undefined)
        setStatus('empty')
        setIsProcessingFile(false)
        setErrors([])
        setClickNumber(0)
        props.closeModal()
    }
    //server request******************************************
    const getFileFromServer = async (type) => {
        // let params = { channelId: "617956d39d5998097034fec7" }
        setIsDownloading(true)
        if (type === "uploadedWithErrors") {
            window.location.href = serverAddress + "getFiles/uploads/" + fileDownloadLink
        } else {
            let res = await GenerateFile()
            if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                window.location.href = serverAddress + "getFiles/uploads/" + res.data.fileName
            }
        }
        setIsDownloading(false)
    }
    const SendFileToServer = async (formData) => {
        let res = await ImportVariantFile(formData, setProgress)

        if (typeof res !== "undefined" && typeof res.data !== "undefined") {
            setUploadedFileAddress(res.data.address)
            setStatus('uploaded')
            setToast({ text: '', type: 'error' })
        } else {
            setStatus('cantUpload')
            setToast({ text: 'آپلود با خطا روبرو شد. لطفا مجددا تلاش کنید.', type: 'error' })
        }
    }
    const processFile = async () => {
        if (typeof file === "undefined") {
            setToast({ text: 'لطفا فایل مورد نظر خود را انتخاب و بارگذاری کنید.', type: 'error' })
        } else {
            // setToast('')
            if (saveCount.count == 0) {
                let temp = []
                setSaveCount({ ...saveCount, count: 1 })
                setIsProcessingFile(true)
                let processRes = await ProcessFile({ address: uploadedFileAddress })
                if (typeof processRes !== "undefined" && typeof processRes.data !== "undefined") {
                    setIsProcessingFile(false)
                    let i = 0
                    setErrors([...processRes.data.errors])
                    // setFile(undefined)
                    let parsedItems = parsedSuccessfully;
                    parsedItems.count = processRes.data.count;
                    parsedItems.parsed = processRes.data.parsed;
                    setParsedSuccessfully({ ...parsedItems });
                    setFileDownloadLink(processRes.data.address);
                    if (processRes.data.errors.length > 0) {
                        setStatus('uploadedWithErrors')
                    } else {
                        setStatus('uploadedWithNoErrors')
                        setSaveCount({ ...saveCount, count: 0 })
                        setFile(undefined)
                        // show success toast and close modal
                        setToast({ text: "فایل اطلاعات با موفقیت ذخیره شد", type: 'success' })
                        setTimeout(() => {
                            closeModalFunction()
                        }, 2700);
                    }
                } else {
                    setIsProcessingFile(false)
                    if (typeof processRes !== "undefined" && typeof processRes.response !== "undefined" && processRes.response.status === 428) {
                        setStatus("uploadedWithWrongContent")
                    }
                    else if (typeof processRes !== "undefined" && typeof processRes.response !== "undefined") {
                        let res = processRes.response.data.error.replace('.', '')
                        setToast({ text: res + ".", type: 'error' })
                    }
                }
            } else {
                setSaveCount({ ...saveCount, count: 0 })
                setFile(undefined)
                // show success toast and close modal
                setToast({ text: "فایل اطلاعات با موفقیت ذخیره شد", type: 'success' })
                setTimeout(() => {
                    closeModalFunction()
                }, 2700);
            }
        }
    }
    //handlers*************************************************
    const dropHandler = async (files, event) => {
        event.preventDefault();
        let reg = new RegExp(/\.xlsx$/)
        if (reg.test(files[0].name)) {
            if (files[0].size < 20000000) {
                setFile(files[0]);
                setToast({ text: '', type: 'error' })
                setStatus('isUploading')
                let formData = new FormData();
                formData.append('file', files[0])
                SendFileToServer(formData)
            } else setToast({ text: 'حجم فایل بیش از حد مجاز است.', type: 'error' })
        } else setToast({ text: 'لطفا فایل مناسب با پسوند' + ' xlsx ' + 'بارگذاری کنید.', type: 'error' })
    }
    const cancelUpload = () => {
        setFile(undefined);
        setStatus('empty')
    }
    const fileInputHandler = async (e) => {
        if (typeof e !== "undefined") {
            let reg = new RegExp(/\.xlsx$/)
            if (reg.test(e.target.files[0].name)) {
                if (e.target.files[0].size < 20000000) {
                    setFile(e.target.files[0]);
                    setToast({ text: '', type: 'error' })
                    setStatus('isUploading')
                    let formData = new FormData();
                    formData.append('file', e.target.files[0])
                    SendFileToServer(formData)
                } else setToast({ text: 'حجم فایل بیش از حد مجاز است.', type: 'error' })
            } else setToast({ text: 'لطفا فایل مناسب با پسوند' + ' xlsx ' + 'بارگذاری کنید.', type: 'error' })
        }
    }
    const retryUpload = () => {
        setStatus("isUploading")
        setToast({ text: '', type: 'error' })
        let formData = new FormData();
        formData.append('file', file)
        SendFileToServer(formData)
    }
    const closeToast = () => {

    }

    return (
        <React.Fragment>
            <Toast
                tag='importDataToast'
                text={toast.text}
                value={toast.text}
                type={toast.type}
                parentClose={closeToast}
            />
            <Modal
                tag='importVariant'
                title='آپلود فایل اطلاعات تنوع‌ها'
                value={props.show}
                parentClose={closeModalFunction}
            >
                {parsedSuccessfully.count > 0 && parsedSuccessfully.parsed > 0 && parsedSuccessfully.parsed === parsedSuccessfully.count ?
                    <div className={style.successWrapper}>
                        <div className={style.icon}>f</div>
                        <p>
                            تکمیل اطلاعات
                            <span> {toPersianNumber(parsedSuccessfully.parsed)} </span>
                            تنوع از
                            <span> {toPersianNumber(parsedSuccessfully.count)} </span>
                            تنوع آپلود شده با موفقیت انجام شد.
                        </p>
                        <Button label="تایید" onclick={closeModalFunction} type="solid" />
                    </div>
                    :
                    <div className={style.wrapper}>
                        {status === "uploadedWithNoErrors" || status === "uploadedWithErrors" ?
                            <React.Fragment>
                                <p className={style.topText}>
                                    تکمیل اطلاعات
                                    {" " + toPersianNumber(parsedSuccessfully.parsed) + " "}
                                    تنوع از
                                    {" " + toPersianNumber(parsedSuccessfully.count) + " "}
                                    تنوع آپلود شده با موفقیت انجام شد. </p>
                                <p className={style.topText}>
                                    شما می‌توانید فایل خطا‌ها را دانلود کنید، آن را تصحیح یا تکمیل و سپس مجددا آپلود
                                    نمایید.
                                </p>
                                <div className={style.wrapErrorFile}>
                                    {
                                        isDownloading ? <div className={style.errorFileDownloadDisabled}>دانلود فایل خطاها</div> :
                                            <div className={style.errorFileDownload}
                                                onClick={() => getFileFromServer("uploadedWithErrors")}>
                                                دانلود فایل خطاها
                                            </div>
                                    }
                                </div>
                            </React.Fragment>
                            : (status === "uploadedWithWrongContent" ?
                                <React.Fragment>
                                    <p className={style.wrongContent}>
                                        فایل
                                        <span>{typeof file !== "undefined" && file.name}</span>،
                                        مطابق فرم اطلاعات تنوع‌ها نیست.
                                    </p>
                                    <p className={style.topText}>
                                        لطفا فرم اطلاعات تنوع‌ها را از اینجا دانلود کنید، اطلاعات را تکمیل و مجددا آپلود
                                        نمایید.
                                    </p>
                                </React.Fragment>
                                : <React.Fragment>
                                    <p className={style.topText}>شما می‌توانید با آپلود فایل اکسل اطلاعات تنوع‌ها، آن‌ها را به‌روز رسانی و تکمیل کنید.</p>
                                    <p className={style.topText}>برای شروع می‌توانید فرم اطلاعات تنوع‌ها را از اینجا دانلود نمایید.</p>
                                </React.Fragment>)
                        }

                        {/* <div className={style.yellowWarning}>
                            <span className={style.warningIcon}>h</span>
                            <p>لطفا پیش از آپلود فایل اکسل دکمه  <strong>به‌روز رسانی تنوع‌ها از دیجی‌کالا</strong> را انتخاب نمایید. </p>
                        </div> */}
                        <div className={style.yellowWarning}>
                            <span className={style.warningIcon}>h</span>
                            <p>در صورتی که تنوع شما دارای <strong>سایزبندی‌های</strong> مختلف و قیمت مرجع یکسان است، به دلیل احتمال محاسبه اشتباه قیمت مرجع از سمت دیجی‌کالا، فیلد افزایش قیمت را بر روی <strong>"محدود به حداکثر سود"</strong> و فیلد رقابت را بر روی <strong>"تنوع"</strong> انتخاب نمایید. </p>
                        </div>

                        <div className={style.downloadButtonContainer}>
                            {
                                isDownloading ?
                                    <>
                                        <div className={style.roller}><div></div><div></div><div></div><div></div></div>
                                        <div className={style.buttonTextDisabled}>
                                            {status === "uploadedWithWrongContent" ? "دانلود فرم (به همراه خطاهای مشخص شده)" : "دانلود فرم اطلاعات تنوع‌ها"}
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className={style.icon}>V</div>
                                        <div className={style.buttonText} onClick={() => getFileFromServer("default")}>
                                            {status === "uploadedWithWrongContent" ? "دانلود فرم (به همراه خطاهای مشخص شده)" : "دانلود فرم اطلاعات تنوع‌ها"}
                                        </div>
                                    </>
                            }
                        </div>
                        <div className={style.downloadButtonContainer}>
                            <a className={style.linkText} href="/guide">
                                <p>مشاهده ویدئو <strong>قیمت‌گذاری تنوع‌ها توسط فایل اکسل</strong> </p>
                            </a>
                        </div>

                        {(errors.length > 0 && status === "uploadedWithErrors") ?
                            <div className={style.errorRowWrapper}>
                                <div className={style.tabel}>
                                    <div className={style.row}>
                                        <div className={style.leftTitle}>علت خطا</div>
                                        <div className={style.rightTitle}>شماره ردیف</div>
                                    </div>
                                    <div className={style.tabelContent}>
                                        {errors.map((data, index) => {
                                            return <div className={style.redRow}>
                                                <div className={style.leftBox}>
                                                    {data.error}
                                                </div>
                                                <div className={style.rightBox}>
                                                    {toPersianNumber(data.rowNumber)}
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            :
                            <div>
                            </div>
                        }
                        <FileUpload
                            dropHandler={dropHandler}
                            status={status}
                            cancel={cancelUpload}
                            fileName={typeof file !== "undefined" && file.name}
                            fileSize={typeof file !== "undefined" && file.size}
                            setSelectedFile={(e) => {
                                fileInputHandler(e)
                            }}
                            retryUpload={() => {
                                setClickNumber(clickNumber + 1);
                                retryUpload()
                            }}
                            progressPercent={progress}
                        />
                        {
                            clickNumber > 2 &&
                            <div className={style.supportInfo}>
                                <p className={style.redText}>در صورت مشکل در فرآیند آپلود فایل، با پشتیبانی در تماس
                                    باشید.
                                    <span>(پاسخ‌گویی از ساعت ۹  تا ۱۷	)</span>
                                </p>

                                <p className={style.phoneNumbers}>
                                    {toPersianNumber("0902 227 8706") + " " + ":شماره تماس"}
                                </p>
                                <p className={style.phoneNumbers}>
                                    {toPersianNumber("0902 227 8705") + " " + ":واتس‌اپ"}
                                </p>
                            </div>
                        }
                        <div className={style.buttonRow}>
                            <Button type="solid" label="ذخیره" onclick={processFile} loading={isProcessingFile} />
                            <Button type="outline" label="انصراف" onclick={closeModalFunction} />
                        </div>
                    </div>}
            </Modal>

        </React.Fragment>
    )
}
export default ImportVariantModal
